<template>
  <div class="nx-signing-modal-signature">
    <h4>Define a signautre</h4>

    <h5 class="mt-4">You can draw your signature below</h5>

    <div class="mt-4 text-left mx-auto" style="width: 640px">
      <b-alert variant="danger" show v-if="error">
        {{ error }}
      </b-alert>

      <b-form-group label="Name">
        <b-form-input name="name" v-model="name" />
      </b-form-group>

      <b-form-group label="Signature">
        <VueSignaturePad
          width="640px"
          height="360px"
          ref="signaturePad"
          class="border m-auto"
          :key="key"
        />
      </b-form-group>

      <div class="mt-2 text-right">
        <b-button class="mx-1" @click="save">Save</b-button>
        <b-button class="mx-1" @click="undo">Undo</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSignaturePad from "vue-signature-pad";
import Vue from "vue";

Vue.use(VueSignaturePad);

export default {
  props: {
    value: {},
  },
  data() {
    return {
      name: "",
      file: null,
      key: 0,
      error: "",
    };
  },
  created() {
    // fix VueSignaturePad not work with modal
    this.$root.$on("bv::modal::shown", () => {
      this.key++;
    });
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { data } = this.$refs.signaturePad.saveSignature();

      if (!data || !this.name) {
        this.error = "Please fill in all the fields";
      } else {
        this.$emit("input", {
          ...this.value,
          signInfo: {
            name: this.name,
            imageData: data?.split("base64,")[1],
          },
        });

        this.$emit("next");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-signature {
  text-align: center;
}
</style>
